
//Menu burger function 
let trigger_burger = 0;
let btrigger = 0;

//job form id variables
var formId = 2;

$('#booking-form').on( "submit", () => {
	if( $( "#rooms" ).val() >= 5 ){
		document.location = "https://www.meetineugene.com/experiences-in-oregon?showform"
	}
} )

function showMenu(){
	if(trigger_burger == 0){
		if(btrigger == 0){
			showMainMenu();
		} else {
			hideABooking();
			setTimeout(function(){
				showMainMenu();
			}, 800);
		}	
	} else{
		closeMainMenu();
	}
}
function showMainMenu(){
	document.getElementById('burger').classList.add('close');
	document.getElementById('burger').getElementsByClassName('text')[0].innerHTML = 'Close';
	document.getElementById('primary-nav').classList.add('open');
	trigger_burger = 1;
}
function closeMainMenu(){
	document.getElementById('burger').classList.remove('close');
	document.getElementById('burger').getElementsByClassName('text')[0].innerHTML = 'Menu';
	document.getElementById('primary-nav').classList.remove('open');
	trigger_burger = 0;
}

function showABooking(){
	document.getElementById('booking-form').classList.add('open');
	document.getElementById('toreserv').innerHTML = 'Close Now';
	btrigger = 1;
}
function hideABooking(){
	document.getElementById('booking-form').classList.remove('open');
	document.getElementById('toreserv').innerHTML = 'Reserve Now';
	btrigger = 0;	
}

//accommodations show video
if(document.getElementsByClassName('image-video').length > 0){
	const roomvideos = document.getElementsByClassName('image-video');
	// for(let j=0; j < roomvideos.length; j++){
	// 	roomvideos[j].addEventListener('mouseover', function(e){
	// 		roomvideos[j].classList.add('active');
	// 		let sibilings = getSiblings(roomvideos[j]);
	// 		for(let m=0; m< sibilings.length; m++){
	// 			if(sibilings[m].classList.contains('image')){
	// 				sibilings[m].classList.add('active');
	// 			}
	// 		}
	// 		playVideo(roomvideos[j]);
	// 	})
	// }
	let theight = 250 + document.getElementsByClassName('intro')[0].offsetHeight;
	let accommodationspos = [];
	for(let m = 0; m < roomvideos.length; m++){
		let ttop =  theight;
		theight = ttop + roomvideos[m].offsetHeight;
		accommodationspos.push(ttop);
	}
	window.addEventListener('scroll', function(){
		let wtop = window.pageYOffset;
		for(let m = 0; m < roomvideos.length; m++){
			if(wtop >=  accommodationspos[m] && wtop < (accommodationspos[m] + 450) ){
				for(let n = 0; n < roomvideos.length; n++){
					
					if(n == m){
						roomvideos[m].classList.add('active');
						let sibilings = getSiblings(roomvideos[m]);
						for(let j=0; j < sibilings.length; j++){
							sibilings[j].classList.add('active');
						}
					} else {
						roomvideos[n].classList.remove('active');
						stopVideo(roomvideos[n]);
						let sibilings = getSiblings(roomvideos[n]);
						for(let j=0; j < sibilings.length; j++){
							sibilings[j].classList.remove('active');
						}
					}
				}
				
			}
		}
	});
	
}

let getSiblings = function (elem) {
	let siblings = [];
	let sibling = elem.parentNode.firstChild;
	for (; sibling; sibling = sibling.nextSibling) {
		if (sibling.nodeType !== 1 || sibling === elem) continue;
		siblings.push(sibling);
	}
	return siblings;
};
let stopVideo = function ( element ) {
	let iframe = element.querySelector( 'iframe');
	if ( iframe ) {
		let iframeSrc = iframe.src;
		iframe.src = iframeSrc;
	}
	
};
let playVideo = function ( element ) {
	let iframe = element.querySelector( 'iframe');
	let video = element.querySelector( 'video' );
	let current = iframe.src;
	if ( iframe ) {
		let iframeSrc = iframe.src;
		if(iframeSrc.indexOf('autoplay') === -1){
			iframe.src = iframeSrc + '&autoplay=1';
		}
	}
	if ( video ) {
		video.play();
	}
	
};

//Show Booking 

function showBooking(){
	if(btrigger == 0){
		
		if(trigger_burger == 0){
			showABooking();
		} else {
			closeMainMenu();
			setTimeout(function(){
				showABooking()
			}, 800);
		}
	} else {
		
		hideABooking();
	}
}


function resizeWindow(){
	if($(window).width() < 1000 ){
		$('.list .item, .overview-list .item').each(function(){
			$(this).find('.image').insertBefore($(this).find('.text'));
		});
	} else{
		$('.list.align-right .item:nth-child(odd)').each(function(){
			$(this).find('.image').insertAfter($(this).find('.text'));
		});
		$('.list.align-left .item:nth-child(even)').each(function(){
			$(this).find('.image').insertAfter($(this).find('.text'));
		});
		$('.overview-list .item:nth-child(odd)').each(function(){
			$(this).find('.image').insertAfter($(this).find('.text'));
		});
	}
}

window.onscroll = function() {
	
	if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
		document.getElementById('header').classList.add('down');	
	} else {
		document.getElementById('header').classList.remove('down');
	}
		
}

//booking select trigger
document.getElementsByClassName('fake-num')[0].innerHTML = document.getElementById('rooms').value;
document.getElementsByClassName('fake-num')[1].innerHTML = document.getElementById('adults').value;

function ChangeNum(id, val){
	document.getElementById(id).previousElementSibling.innerHTML = val;
}


//tocheck array per page
let checkdiv = [];
for(var j = 0; j < document.getElementsByClassName('tocheck').length; j++){
	var classList = document.getElementsByClassName('tocheck')[j].className.split(/\s+/);
	for (var i = 0; i < classList.length; i++) {
	    if (classList[i] === 'tocheck') {
	        checkdiv.push(classList[i + 1]);
	    }
	}
}
let checktop = [];
for(var j = 0; j < document.getElementsByClassName('tocheck').length; j++){
	var classtop = document.getElementsByClassName('tocheck')[j].offsetTop;
	checktop.push(classtop);	
}

let checkdata = [];
if(document.getElementsByClassName('datatags').length > 0 ){
	var newdata = document.getElementsByClassName('datatags')[0].innerHTML.split(',');
	for(var j = 0; j < document.getElementsByClassName('tocheck').length; j++){
		var datatop = newdata[j];
		checkdata.push(datatop);	
	}
} else {
	for(var j = 0; j < document.getElementsByClassName('tocheck').length; j++){
		var datatop = document.getElementsByClassName('tocheck')[j].getAttribute('data-top');
		checkdata.push(datatop);	
	}
}

(function( $ ) {
	$(function() {
	    $( window ).scroll(function() {
	
			clearTimeout( $.data( this, "scrollCheck" ) );
			$.data( this, "scrollCheck", setTimeout(function() {
				
				for(var i=0; i < checktop.length ; i++){
					if( ($(document).scrollTop() + 350) >= checktop[i] && ($(document).scrollTop() + 350) < checktop[i + 1]){
						$('#linemenu').attr('class','').addClass(checkdiv[i]);
						
					
							$('#linemenu .target').text(checkdata[i]);
						
						
						
						//console.log([i]);
					}
					if(($(document).scrollTop() + 350) >= checktop[checktop.length - 1] ){
						$('#linemenu').attr('class','').addClass(checkdiv[i]);
						$('#linemenu .target').text(checkdata[i]);
					}
				}
				
				

				$('#linemenu').animate({ top: $(document).scrollTop() + 350 }, 1200, 'easeOutExpo', function(){
					if($('#linemenu').offset().top >= $('#footer').offset().top){
						$('#linemenu').animate({ top: $('#linemenu').offset().top - 150  }, 800, 'easeOutExpo');
					}
				});
					
				
					
				
			}, 200) );
		});

		//if job app form
		if(document.getElementById('form_id-603')){
			let gdprWrap = document.getElementById('form_id-603').getElementsByClassName('gdpr-wrap')[0]
			let newDateWrap = document.createElement('div')
			newDateWrap.classList.add('form-module__field')
			newDateWrap.classList.add('col-6')
			newDateWrap.classList.add('bottom-aligned')

			//current day
			let today = new Date();
			const monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"]
			let dd = String(today.getDate()).padStart(2, '0');
			newDateWrap.innerHTML = 'Signed today: <span>' + monthNames[today.getMonth()] + ' ' + dd + '/ ' + today.getFullYear() + '</span>'

			document.getElementById('form_id-603').insertBefore(newDateWrap,gdprWrap)

			//Add more employers button
			addEmployersbutton();
		}

	});

})( jQuery );


//homemap
function showPin(datapin){
	
	var current = datapin.getAttribute('data');
	
	for(var j = 0; j < document.getElementsByClassName('homepin').length; j++){
		document.getElementsByClassName('homepin')[j].classList.remove('active');
	}
	for(var j = 0; j < document.getElementsByClassName('homepin').length; j++){
		if(document.getElementsByClassName('homepin')[j].getAttribute('data') == current ){
			document.getElementsByClassName('homepin')[j].classList.add('active');
		}
	}
}


function scrollDown(){
	if($('body.eugene-map #content').length > 0 || $('body.photos #content').length > 0){
		$('#header').addClass('down');
	}
	if($('#bottom-content').hasClass('noheader')){
		$('#header').addClass('down');
	}
}

$(document).ready(function () {

	//line
	$('.menu-line').height($(document).height() - 240 );

	//Call function with browser is resized.
    $(window).resize(function (event) {
         resizeWindow();
    });
    

    //Acts when scroll down page.
    $(window).scroll(function (event) {
    	scrollDown()
	});

	// Main Nav Dropdown
/*
    $("#primary-nav li").hover(function(){

        $(this).addClass("hover");
        $('ul.submenu',this).fadeIn(200);

    }, function(){

        $(this).removeClass("hover");
        $('ul.submenu',this).fadeOut(200);

    });
*/

	//Home page scroll down arrow. If present.
	$('.arrow-home').click(function(event) {
	    $('body, html').animate({
	        scrollTop: $(window).height()-$('header').outerHeight()*2},
	        800, 'easeOutExpo');
	});
	
	//Remove empty <p> tags created by tinymce
	$('p').each(function() {
	    var $this = $(this);
	    if($this.html().replace(/\s|&nbsp;/g, '').length == 0)
	        $this.remove();
	});

	//Event Tracking
	//this class should be add to any link to the booking engine
	//GA parametters :  ga('send', 'event', [eventCategory], [eventAction], [eventLabel]);
    $('.book-now').on('click', function () {
         if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
    });
	//this class should be add to the header widget submit button
    $('.bookNow').on('click', function () {
         if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
    });

	//Check in and check out datepicker for booking engine
	$( "#CheckIn" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 1,
		dateFormat:'mm.dd.yy',
		minDate: 0,
		maxDate: '+365D',
		onSelect: function( selectedDate ) {
			var getDate = $(this).datepicker('getDate');
        	var newDate = new Date(getDate.getTime());
        	newDate.setDate(newDate.getDate() + 1);
			$( "#CheckOut" ).datepicker( "setDate", newDate );
			$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
		}
	});
	
	$( "#CheckOut" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		dateFormat:'mm.dd.yy',
		numberOfMonths: 1,
		maxDate: '+365D',
		onSelect: function( selectedDate ) {
			//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
		}
	});
	
	// Map: Return to previous page button. Change body id to match map template's name.
	$('body.eugene-map #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
	
	$('.btnSubmit').removeClass('btn');
	
	if($('body.sitemap').length > 0){
		$('#top-content').remove();
		$('#bottom-content').addClass('noheader');
		$('.intro h1').wrapInner('<span></span>');
		$('<span></span>').insertBefore($('.intro h1 span'));
		$('#footer .foot #third-nav ul li:last-child a').addClass('active');
	}
    if($('#amenityMenu').length > 0){
        $('#amenityMenu dl dt').each(function(){
            if($(this).attr('data-rel') == 'wine-tasting-room'){
                console.log('wine');
                $(this).find('a').html('Tasting Rooms');
            }
        });
    }

    $('form .btnSubmit').click(function(){
        setTimeout(function(){
            $('p#thankyou').fadeOut(500);
        }, 6000);
	});
	
	//popup hard coded
	/*Only load Intro at First*/
	var COOKIE_NAME = 'pop_cookie';
	var go = $.cookie(COOKIE_NAME);
	if (go == null) {

		$.cookie(COOKIE_NAME, 'test', {
			path: '/',
			expires: 30
		});
		
		setTimeout(function(){
			$('.popup-container').addClass('active');
		}, 2500);
		
		console.log("cookie");

	} else {
		console.log("no-cookie");
	}
	$('.popup-container__close').click(function(){
		$('.popup-container').removeClass('active');
	});
	
});

$(window).on('load', function() {
	scrollDown();
	resizeWindow();
   	//Slick Slider
	$('.sym-slides').slick();
	
});



function addEmployersbutton() {
	let jobForm = document.getElementById('form_id-603');
	let referenceElement = document.getElementById('id_65_603');

	let newButton = document.createElement('a');
	newButton.classList.add('js-add-new-employer');
	newButton.innerHTML = 'Add Employer';
	jobForm.insertBefore(newButton,referenceElement)

	newButton.addEventListener('click', function(){
		let newFieldset = document.createElement('div');
		newFieldset.setAttribute('id','id_603_'+formId);
		newFieldset.classList.add('job-form-fieldset');

		newFieldset.innerHTML = '<h3>Employer '+formId+'</h3><div class="form-module__field input col-4"><label class="hidden" for="id603'+formId+'">Employer Name</label><input name="employer_name_'+formId+'" type="text" id="id603'+formId+'" placeholder="Employer Name"></div><div class="form-module__field input col-4"><label class="hidden" for="id6031'+formId+'">Supervisor</label><input name="supervisor_'+formId+'" type="text" id="id6031'+formId+'" placeholder="Supervisor"></div><div class="form-module__field input col-4"><label class="hidden" for="id6032'+formId+'">Address</label><input name="employer_address_'+formId+'" type="text" id="id6032'+formId+'" placeholder="Employer Address"></div><div class="form-module__field input col-4"><label class="hidden" for="id6033'+formId+'">Phone</label><input name="employer_phone_'+formId+'" type="text" id="id6033'+formId+'" placeholder="Employer Phone"></div><div class="form-module__field input col-4"><label class="hidden" for="id6034'+formId+'">Position</label><input name="employer_position_'+formId+'" type="text" id="id6034'+formId+'" placeholder="Position Held"></div><div class="form-module__field input col-12"><label class="hidden" for="id6035'+formId+'">Reason</label><input name="reason_leave_'+formId+'" type="text" id="id6035'+formId+'" placeholder="Reason for leaving"></div><div class="form-module__field date col-6"><label class="hidden" for="id6036'+formId+'">Start Date</label><input name="start_date_'+formId+'" type="text" class="newdatepicker" id="id6036'+formId+'" placeholder="Start Date" autocomplete="off"></div><div class="form-module__field date col-6"><label class="hidden" for="id6037'+formId+'">End Date</label><input name="end_date_'+formId+'" type="text" class="newdatepicker" id="id6037'+formId+'" placeholder="End Date" autocomplete="off"></div><div class="form-module__field input col-12"><label class="hidden" for="id6038'+formId+'">Duties</label><input name="duties_'+formId+'" type="text"  id="id6038'+formId+'" placeholder="Duties"><div class="form-module__field--description">List the duties and responsibilities for Employer</div></div>';
		formId++;
		jobForm.insertBefore(newFieldset,newButton);

		setTimeout(function(){
			$('.newdatepicker').datepicker();
		},500);
	})
}